import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Link, useNavigate } from 'react-router';
import { useAtom, useSetAtom } from 'jotai';
import { userAtom, userProfileModalOpenAtom } from '../atoms/userAtom';
import { selectedMediaAtom, selectedSeasonAtom, selectedEpisodeAtom } from '../atoms/selectedMediaAtoms';
import { wordsDataAtom, wordsLoadingAtom, wordsErrorAtom, getWordsDataAtomDefaults } from '../atoms/wordsAtoms';
import { lastWatchedAtom } from '@app/atoms/libraryAtoms';
import { requestLogout } from '../utils/api';
import Avatar from './Avatar';

const ProfileModal = () => {
  const navigate = useNavigate();
  const [user, setUser] = useAtom(userAtom);
  const [show, setShow] = useAtom(userProfileModalOpenAtom);
  const [loading, setLoading] = useState(false);

  const setSelectedMedia = useSetAtom(selectedMediaAtom);
  const setSelectedSeason = useSetAtom(selectedSeasonAtom);
  const setSelectedEpisode = useSetAtom(selectedEpisodeAtom);
  const setWordsData = useSetAtom(wordsDataAtom);
  const setWordsLoading = useSetAtom(wordsLoadingAtom);
  const setWordsError = useSetAtom(wordsErrorAtom);
  const setLastWatched = useSetAtom(lastWatchedAtom);

  const handleClose = () => setShow(false);

  const handleLogout = async () => {
    setLoading(true);
    await requestLogout();
    setUser(null);
    setSelectedMedia(null);
    setSelectedSeason(null);
    setSelectedEpisode(null);
    setWordsData(getWordsDataAtomDefaults());
    setWordsLoading(false);
    setWordsError('');
    setLoading(false);
    setLastWatched([]);
    setShow(false);
    navigate('/');
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {user ? (
          <div>
            <div className="d-flex align-items-center mb-3 flex-column">
              <Avatar src={user.avatar} className="mb-3" />
              <div className="fw-semibold">{user.email}</div>
            </div>
          </div>
        ) : (
          <div className="text-muted">You are not signed in.</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {user ? (
          <Button variant="link" onClick={handleLogout} disabled={loading} className="text-danger text-decoration-none">Logout</Button>
        ) : (
          <Link to="/" state={{ auth: true }} className="btn btn-primary" onClick={handleClose}>Sign in</Link>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ProfileModal;


